__webpack_require__.p = "/commercial-intelligence-ui/";